import { Injectable } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { ScreenSize } from '../screen-size.enum';

const DEFAULT_CHUNK_SIZE = 4.5;
const DEFAULT_SWIPE_SIZE = 4;

export enum CHUNK_SIZE {
    EXTRA_SMALL_MOBILE_DEVICE = 2.5,
    STANDARD_MOBILE_DEVICE = 3.2,
    LAPTOP = 3.5,
    LAPTOP_LANDSCAPE = 4,
    LARGE_DEVICE = 4.5,
}

export enum SWIPE_SIZE {
    EXTRA_SMALL_MOBILE_DEVICE = 2,
    LAPTOP = 3,
}

@Injectable({
    providedIn: 'root',
})
export class SwiperConfigService {
    constructor(private readonly deviceService: DeviceService) {}

    getChunkSwiperSize(isGamesAvailable: boolean, isFutureGridEnabled: boolean = true): SwiperOptionConfig {
        const isTouch = this.deviceService.isTouch;
        let swiperConfig: SwiperOptionConfig = {
            chunkSize: DEFAULT_CHUNK_SIZE,
            swipeSize: DEFAULT_SWIPE_SIZE,
            enableNavigation: !isTouch,
        };
        if (!isGamesAvailable || !isTouch || !isFutureGridEnabled) {
            return swiperConfig;
        }
        swiperConfig.chunkSize = this.getChunkSize();
        swiperConfig.swipeSize = this.getSwipeSize();
        return swiperConfig;
    }

    private getSwipeSize(): number {
        if (this.deviceService.windowWidth() <= ScreenSize.SMALL_MOBILE_DEVICE) {
            return SWIPE_SIZE.EXTRA_SMALL_MOBILE_DEVICE;
        }
        if (this.deviceService.windowWidth() >= ScreenSize.STANDARD_MOBILE_DEVICE && this.deviceService.windowWidth() < ScreenSize.LAPTOP) {
            return SWIPE_SIZE.LAPTOP;
        }
        return DEFAULT_SWIPE_SIZE;
    }

    private getChunkSize(): number {
        if (this.deviceService.windowWidth() <= ScreenSize.SMALL_MOBILE_DEVICE) {
            return CHUNK_SIZE.EXTRA_SMALL_MOBILE_DEVICE;
        }
        if (this.deviceService.windowWidth() <= ScreenSize.STANDARD_MOBILE_DEVICE) {
            return CHUNK_SIZE.STANDARD_MOBILE_DEVICE;
        }
        //for ipad/tab in portrait
        if (this.deviceService.windowWidth() > ScreenSize.STANDARD_MOBILE_DEVICE && this.deviceService.windowWidth() <= ScreenSize.LAPTOP) {
            return CHUNK_SIZE.LAPTOP;
        }
        //for ipad/tab in landscape
        if (this.deviceService.windowWidth() > ScreenSize.LAPTOP && this.deviceService.windowWidth() <= ScreenSize.LAPTOP_LANDSCAPE) {
            return CHUNK_SIZE.LAPTOP_LANDSCAPE;
        }
        return CHUNK_SIZE.LARGE_DEVICE;
    }
}

export interface SwiperOptionConfig {
    chunkSize: number;
    swipeSize: number;
    enableNavigation: boolean;
}
